import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

//Servicios 
import { CombustiblesService } from '@/app/services/combustibles.service';

//Modelos
import { Combustibles } from '@/app/models/Combustibles';

//Librerías externas
import {MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-crear-combustible',
    templateUrl: './crear-combustible.component.html',
    styleUrls: ['./crear-combustible.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CrearCombustibleComponent {
  private spinner = inject(NgxSpinnerService);

  //NgModel 
  CombustibleRQ = {
    idCombustible: null,
    tipo: null,
    descripcion: null
  };

  //Bandera global para cerrar el modal
  hasFinished: boolean = false;

  //Lista de combustibles
  listaCombustibles: Combustibles[] = [];

  constructor(
    private combustiblesService: CombustiblesService,
    private toastr: ToastrService, 
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CrearCombustibleComponent>,

   ){
    this.obtenerCombustibles();
   }


   obtenerCombustibles(){
    this.spinner.show();

    this.combustiblesService.obtenerCombustibles().subscribe({
      next: (data: any)=>{
        console.log(data);
        this.listaCombustibles = data.Combustible;
        console.log(this.listaCombustibles);
        this.spinner.hide();

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  //Submit y crear combustible
  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas crear un nuevo combustible?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.crearCombustible();
        }
      });
    }
  }

  crearCombustible(){
    this.spinner.show();

    this.combustiblesService.crearCombustibles(this.CombustibleRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Combustible creado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();

        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado el combustible. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }
}
